/**
 * 예약 추이 차트 컴포넌트
 */

import React from 'react';
import { Card } from 'react-bootstrap';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { BookingTrend } from '../../types/dashboard';
import './Chart.css';

interface BookingChartProps {
  data: BookingTrend[];
}

const BookingChart: React.FC<BookingChartProps> = ({ data }) => {
  return (
    <Card className="chart-card">
      <Card.Body>
        <Card.Title className="chart-title">예약 추이</Card.Title>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255, 255, 255, 0.1)" />
            <XAxis
              dataKey="date"
              stroke="#CCCCCC"
              style={{ fontSize: '12px' }}
            />
            <YAxis
              stroke="#CCCCCC"
              style={{ fontSize: '12px' }}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: 'var(--color-blue-gray)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '8px',
                color: '#fff',
              }}
            />
            <Line
              type="monotone"
              dataKey="bookings"
              stroke="#00BCD4"
              strokeWidth={2}
              dot={{ fill: '#00BCD4', r: 4 }}
              activeDot={{ r: 6 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </Card.Body>
    </Card>
  );
};

export default BookingChart;

